import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import "./MapView.css";

// Create a simple version of MapView that directly uses Leaflet API
// instead of react-leaflet components and hooks
const MapView = ({ latitude, longitude, zoom = 13, height = 300 }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  // Default coordinates (Delhi, India)
  const defaultLat = 28.5561;
  const defaultLng = 77.1;

  // Ensure valid coordinates
  const validLat = typeof latitude === "number" && !isNaN(latitude) ? latitude : defaultLat;
  const validLng = typeof longitude === "number" && !isNaN(longitude) ? longitude : defaultLng;

  // Initialize and clean up the map
  useEffect(() => {
    if (!mapRef.current) return;

    // Create map if it doesn't exist
    if (!mapInstanceRef.current) {
      // Create the map instance
      mapInstanceRef.current = L.map(mapRef.current).setView([validLat, validLng], zoom);
      
      // Add the tile layer (OpenStreetMap)
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(mapInstanceRef.current);

      // Create custom icon
      const icon = L.icon({
        iconUrl: markerIconPng,
        shadowUrl: markerShadowPng,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });

      // Add marker
      markerRef.current = L.marker([validLat, validLng], { icon })
        .addTo(mapInstanceRef.current)
        .bindPopup("This is your location!");
    } else {
      // Update existing map and marker
      mapInstanceRef.current.setView([validLat, validLng], zoom);
      if (markerRef.current) {
        markerRef.current.setLatLng([validLat, validLng]);
      }
    }

    // Ensure map is properly sized
    mapInstanceRef.current.invalidateSize();

    // Cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        markerRef.current = null;
      }
    };
  }, [validLat, validLng, zoom]);

  return (
    <div className="map-container" style={{ height, width: "100%" }}>
      <div ref={mapRef} style={{ height: "100%", width: "100%" }} />
    </div>
  );
};

export default MapView;
